export function getGAClientId() {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let splitCookie = el.split("=");
    let key = splitCookie[0].trim();
    let value = splitCookie[1];
    cookie[key] = value;
  });
  return cookie["_ga"].substring(6);
}

export function getGASessionId() {
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith("_ga_")) {
      const parts = cookie.split(".");
      const sessionID = parts[2];
      if (sessionID[0] === "s") return parts[2].substring(1, 11);
      return parts[2];
    }
  }
  return null;
}
